<template>
  <div>
    <div class="cell-layer">
      <span :style="`color:${guideColor}`">{{guide}}</span>
      <a href="#" @click.prevent="goPpvPage">
        <span :style="`color:${destinationColor}`">{{destination}}</span>&nbsp;
        <span :style="`color:${actionColor}`">{{action}}</span>
      </a>
    </div>
    <div class="cell-notice">
      <span :style="`color:${noticeColor}`">{{notice}}</span>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { hasUserConfirmPPV } from '@/common/util/common'
export default {
  componentName: 'PpvWrapper',
  props: {
    buttonInfo: {
      type: Object
    }
  },
  methods: {
    async goPpvPage () {
      const referer = this.$route.path
      if (hasUserConfirmPPV()) {
        setTimeout(() => {
          this.$router.push(`/supermultisection/GN18?referer=${referer}`)
        }, 2000)
        this.$toast({ message: get(this.buttonInfo, 'confirmation.guide_text', '') })
      } else {
        if (await utils.asyncConfirm(
          `${get(this.buttonInfo, 'confirmation.guide_title', '')} <br/>${get(this.buttonInfo, 'confirmation.guide_text', '')}`
        )) {
          utils.cookies.setMovieUiCodeToGN17()
          this.$router.push(`/supermultisection/GN18?referer=${referer}`)
        }
      }
    }
  },
  computed: {
    destination () {
      return get(this.buttonInfo, ['destination', 'title'], '')
    },
    destinationColor () {
      return get(this.buttonInfo, ['destination', 'color'], '#FFFFFF')
    },
    action () {
      return get(this.buttonInfo, ['action', 'title'], '')
    },
    actionColor () {
      return get(this.buttonInfo, ['action', 'color'], '#FFFFFF')
    },
    guide () {
      return get(this.buttonInfo, ['guide', 'title'], '')
    },
    guideColor () {
      return get(this.buttonInfo, ['guide', 'color'], '#FFFFFF')
    },
    notice () {
      return get(this.buttonInfo, ['notice', 'title'], '')
    },
    noticeColor () {
      return get(this.buttonInfo, ['notice', 'color'], '#FFFFFF')
    }
  }
}
</script>
<style scoped>
  /* 신규 CSS */
  .cell-layer{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    padding-top: 44px;
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;
  }

  .cell-layer > span{
    display: block;
    font-size: 20px;
    line-height: 29px;
    color: #fff;
  }

  .cell-layer > a{
    display: inline-block;
    height: 48px;
    padding: 0 24px;
    border-radius: 24px;
    background-color: #1341f9;
    font-size: 16px;
    line-height: 46px;
    color: #fff;
  }

  .cell-layer > span + a{
    margin-top: 4px;
  }

  .cell-notice{
    position: relative;
    z-index: 10;
    text-align: center;
  }

  .cell-notice > span{
    display: block;
    padding: 10px 0;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
  }
</style>
